export const CONTRACT_COST_COUNT_LIMIT = 1024;
export const SC_SPEC_DOC_LIMIT = 1024;
export const SCSYMBOL_LIMIT = 32;
export const MASK_ACCOUNT_FLAGS = 7;
export const MASK_ACCOUNT_FLAGS_V17 = 15;
export const MAX_SIGNERS = 20;
export const MASK_TRUSTLINE_FLAGS = 1;
export const MASK_TRUSTLINE_FLAGS_V13 = 3;
export const MASK_TRUSTLINE_FLAGS_V17 = 7;
export const MASK_OFFERENTRY_FLAGS = 1;
export const MASK_CLAIMABLE_BALANCE_FLAGS = 1;
export const MASK_LEDGER_HEADER_FLAGS = 7;
export const AUTH_MSG_FLAG_FLOW_CONTROL_BYTES_REQUESTED = 200;
export const TX_ADVERT_VECTOR_MAX_SIZE = 1000;
export const TX_DEMAND_VECTOR_MAX_SIZE = 1000;
export const MAX_OPS_PER_TX = 100;
export const LIQUIDITY_POOL_FEE_V18 = 30;
